export function PokemonTypeImage(props) {
  const typeId = props.typeId || props.type?.id || "normal";

  return <img src={`/img/pokemon-types/512/${typeId}.png`} {...props} />;
}
